import { useEffect, useRef, useState } from "react";
import UserPopUp from "../UserPopUp";
import { createSubmitGuard } from "../../utils/submitGuard";
import { useActionDialog } from "../ActionDialog";
import { describeMatches } from "../../utils/duplicateAddressCheck";
import {
  hasNoClient,
  describeMissing,
} from "../../utils/listingRequestValidation";
import { useStateValue } from "../../context/StateProvider";
import SelectPopUp from "./select-dropdown";
import { Calendar, MoveRight } from "lucide-react";
import { Autocomplete } from "@react-google-maps/api";
import { FaPlus } from "react-icons/fa6";
import { AiFillMinusCircle } from "react-icons/ai";
import { Pencil, Trash2 } from "lucide-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  getContactsForUser,
  getAlldealforAdmin,
  getContactsByIds,
  getListingAppointments,
  getTaskTemplate,
  saveitemwithid,
  saveListingLead,
  updateListingLead,
  saveBuyerLead,
  saveListingAppointment,
  findDuplicatesForAddress,
} from "../../utils/firebasefunctions";
import { toast } from "react-toastify";
import { actionType } from "../../context/reducer";
import LeadSourcePopup from "../deals/leadSourceFilter";
import ClientSuggesstionPopup from "../ClientSuggesstionPopup";
import AddClientPicker from "../new-contact/AddClientPicker";
import ContactEditDrawer from "../new-contact/ContactEditDrawer";
import { normalizeContact } from "../../utils/contactNormalize";
import { buildIntakeLead } from "../../utils/intakeLead";
import { addContact, updateContact } from "../../utils/contactsApi";
import { LISTING_FORM_TYPES } from "../../utils/portalForms";
import { SKIP_GMAIL_GATE } from "../../utils/devBypass";
import {
  formatDates,
  newmessagesuccess,
  notifyApprovers,
  emailListingRequestRecipients,
  stripCountry,
} from "../../utils/helper";
import PageHeader from "../PageHeader";

function MainListRequest() {
  // In-app dialog, not window.confirm: Chrome can suppress native dialogs and
  // the button then silently does nothing.
  const { confirm, dialog } = useActionDialog();
  const [{ employees, user, leadsource, users }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Default to "seller" so visiting the route without a ?type= query param
  // still renders a valid (Listing) form rather than a half-rendered shell.
  const type = searchParams.get("type") || "seller";
  const [agentpopup, setagentpopup] = useState(false);
  const [formTypePopup, setFormTypePopup] = useState(false);
  const [propertyTrustPopup, setPropertyTrustPopup] = useState(false);
  const [sellerPopup, setSellerPopup] = useState(false);
  const [sellHomePopup, setsellHomePopup] = useState(false);
  const [photoBookPopup, setPhotoBookPopup] = useState(false);
  const [preListingPopup, setPreListingPopup] = useState(false);
  const [clientReferPopup, setClientReferPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tasks, setTasks] = useState({});
  const [leadpopup, setleadpopup] = useState(false);
  const [selectedLead, setSelectedLead] = useState("");
  const [clientpopup, setclientpopup] = useState(false);
  const [clientfieldfocus, setclientfieldfocus] = useState("");
  const [clientindexfocus, setclientindexfocus] = useState(0);
  const [contactSyncData, setContactSyncData] = useState([]);
  const [dealContactsData, setDealContactsData] = useState([]);
  // New client picker / edit drawer state
  const [pickerOpen, setPickerOpen] = useState(false);
  const [editingContact, setEditingContact] = useState(null); // normalized contact
  const [creatingContact, setCreatingContact] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);

  const hiddenDateRef = useRef(null);
  const hiddenDateRef2 = useRef(null);
  const hiddenDateRef3 = useRef(null);
  const hiddenDateRef4 = useRef(null);
  const autoCompleteRef = useRef(null);

  const formTypes = LISTING_FORM_TYPES;

  const yesNoOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  const sellerDisclouser = [
    { label: "Sellers Disclosure", value: "seller_disclosure" },
    {
      label: "Sellers Disclosure Alternative",
      value: "seller_disclosure_alternative",
    },
    {
      label: "Sellers Disclosure Alternative with AS-IS",
      value: "seller_disclosure_alternative_as_is",
    },
  ];

  const openDatePicker = () => {
    hiddenDateRef.current.showPicker();
  };

  const openDatePicker2 = () => {
    hiddenDateRef2.current.showPicker();
  };

  const openDatePicker4 = () => {
    hiddenDateRef4.current.showPicker();
  };

  const openDatePicker3 = () => {
    hiddenDateRef3.current.showPicker();
  };

  const handlePlaceChanged = () => {
    const place = autoCompleteRef.current.getPlace();

    if (!place.geometry) return;

    // We used to break out city/state/zip into a separate field. The
    // formatted_address already contains them, so we store the single
    // canonical address string and skip the redundant breakdown.
    setFormData({
      ...formData,
      propertyAddress: stripCountry(place.formatted_address),
      propertyLocation: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      },
    });
  };

  const [formData, setFormData] = useState({
    agentName: "",
    agentId: "",
    leadsource: "",
    formType: "",
    listingDate: "",
    fileDeadline: "",
    formDeadline: "",
    fileFormat: "",
    propertyAddress: "",
    propertyLocation: {
      lat: "",
      lng: "",
    },
    commission: "",
    sellerDisclosure: "",
    propertyTrust: "",
    sellHome: "",
    photoBook: "",
    preListing: "",
    expirationdate: "",
    dropOff: "",
    clientReferal: "",
    referredSendGift: "",
    notes: "",
  });

  const [step2Data, setStep2Data] = useState({
    clientinfo: [""],
  });

  // Prefill handed over from a listing-pipeline lead ("Appt Set" → Open
  // Listing Request). Applied once; keeping the payload in a ref also lets
  // submit LINK that lead to the new file instead of minting a duplicate
  // pipeline lead, and stops the Employee agent-auto-fill from clobbering a
  // prefilled agent.
  const location = useLocation();
  const prefillRef = useRef(null);
  useEffect(() => {
    const p = location.state?.listingRequestPrefill;
    if (!p || prefillRef.current) return;
    prefillRef.current = p;
    setFormData((prev) => ({
      ...prev,
      agentId: p.agentId || prev.agentId,
      agentName: p.agentName || prev.agentName,
      leadsource: p.leadsource || prev.leadsource,
      listingDate: p.listingDate || prev.listingDate,
      propertyAddress: p.propertyAddress || prev.propertyAddress,
      notes: p.notes || prev.notes,
    }));
    if (p.leadsourceAbbreviation) setSelectedLead(p.leadsourceAbbreviation);
    if (Array.isArray(p.clientinfo) && p.clientinfo.length)
      setStep2Data({ clientinfo: p.clientinfo });
    // Strip the prefill from the history entry: without this, Back after
    // submitting remounts the form half-filled (reads as "did my submit
    // fail?") and a re-submit would re-point the lead at a SECOND file,
    // orphaning the first.
    navigate(location.pathname + location.search, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const handleAddClient = () => {
    setPickerOpen(true);
  };

  // Drop any stale "Client is required" errors. The client list just changed,
  // so the next Submit re-validates from scratch — without this, an error set
  // on an empty placeholder slot lingers and gets painted onto the real client
  // that later fills that slot.
  const clearClientErrors = () => {
    setErrors((prev) => {
      if (!prev.clientErrors) return prev;
      const updated = { ...prev };
      delete updated.clientErrors;
      return updated;
    });
  };

  // Append a contact ID to clientinfo (replacing the first empty slot if one
  // exists from legacy state, otherwise pushing onto the end).
  const attachClient = (contactId) => {
    setStep2Data((prev) => {
      const arr = [...prev.clientinfo];
      if (arr.includes(contactId)) {
        toast.info("That client is already added");
        return prev;
      }
      const emptyIdx = arr.findIndex((id) => !id);
      if (emptyIdx >= 0) arr[emptyIdx] = contactId;
      else arr.push(contactId);
      return { ...prev, clientinfo: arr };
    });
    clearClientErrors();
  };

  const handleRemoveClient = (index) => {
    setStep2Data((prev) => ({
      ...prev,
      clientinfo: prev.clientinfo.filter((_, i) => i !== index),
    }));
    clearClientErrors();
  };

  // Open the edit drawer pre-filled with this client's data.
  const handleEditClient = (rawContact) => {
    setEditingContact(normalizeContact(rawContact));
  };

  const handleSaveEditedContact = async (form) => {
    setContactSaving(true);
    try {
      const result = await updateContact({
        user,
        contact: editingContact,
        form,
      });
      // Refresh both caches with the patched contact.
      const patch = (c) =>
        c?.id === editingContact.id ? { ...c, ...result } : c;
      setDealContactsData((prev) => prev.map(patch));
      setContactSyncData((prev) => prev.map(patch));
      toast.success("Client updated");
      setEditingContact(null);
    } catch (err) {
      console.error("Client save failed:", err);
      toast.error(err.message || "Save failed");
    } finally {
      setContactSaving(false);
    }
  };

  // Create a brand-new contact and attach it to this request.
  const handleCreateNewContact = async (form) => {
    setContactSaving(true);
    try {
      if (!user?.gmailtoken?.access_token) {
        toast.error("Connect Gmail in Settings before adding a new contact");
        return;
      }
      const created = await addContact({ user, contact: form });
      setContactSyncData((prev) => [
        { ...created, id: created.firebaseId, createdBy: user.id },
        ...prev,
      ]);
      attachClient(created.firebaseId);
      toast.success("Client added");
      setCreatingContact(false);
    } catch (err) {
      console.error("Create contact failed:", err);
      toast.error(err.message || "Create failed");
    } finally {
      setContactSaving(false);
    }
  };

  const handleClientChange = (index, field, value) => {
    setStep2Data((prev) => {
      const updated = [...prev.clientinfo];
      updated[index][field] = value;
      return { ...prev, clientinfo: updated };
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors.clientErrors?.[index]) {
        updatedErrors.clientErrors[index][field] = "";
      }
      return updatedErrors;
    });
  };

  const handleNavigate = () => {
    if (user.role === "Supervisor") {
      navigate("/dashboard/deals");
    } else {
      navigate("/dashboard");
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // ✅ remove error instantly
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors[field]) {
        delete updatedErrors[field];
      }
      return updatedErrors;
    });
  };

  const getContactById = (id) => {
    return (
      dealContactsData.find((c) => c.id === id) ||
      contactSyncData.find((c) => c.id === id) ||
      {}
    );
  };

  const [errors, setErrors] = useState({ clientErrors: [] });

  // One click = one record. The button used to stay clickable while saving, so
  // a second click ran this whole handler again and minted a duplicate deal AND
  // a duplicate lead (2026-08-26: two of each, 266ms apart, team emailed twice).
  const submitGuard = useRef(createSubmitGuard());

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitGuard.current(() => submitListingRequest(e));
  };

  const submitListingRequest = async (e) => {

    // Block submission if Gmail isn't connected: the team-notification email
    // is sent *as* the submitter, so without their token it silently fails
    // and nobody on the team finds out about the request.
    // On localhost the Gmail gate is bypassed (SKIP_GMAIL_GATE) so requests can
    // be submitted without connecting Gmail — the deal still saves; only the
    // team-notification email no-ops. The gate stays active in the live build.
    if (!user?.gmailtoken?.access_token && !SKIP_GMAIL_GATE) {
      toast.error(
        "Connect Gmail in Settings before submitting — the team can't be notified without it.",
      );
      return;
    }

    let newErrors = {};
    let clientErrors = [];

    if (!formData.agentName) {
      newErrors.agentName = "Agent is required";
    }

    if (!formData.leadsource) {
      newErrors.leadsource = "Lead is required";
    }

    if (!formData.fileFormat) {
      newErrors.fileFormat = "File format is required";
    }

    if (type === "seller") {
      if (!formData.formType) {
        newErrors.formType = "Form Type is required";
      }

      if (!formData.propertyAddress) {
        newErrors.propertyAddress = "Property address is required";
      }

      if (!formData.propertyTrust) {
        newErrors.propertyTrust = "Property trust is required";
      }

      if (!formData.preListing) {
        newErrors.preListing = "Pre-Listing drop off is required";
      }

      // Only require "Who referred & send gift?" when a client referral
      // actually happened — the red asterisk on the field follows the same rule.
      if (formData.clientReferal === "yes") {
        if (!formData.referredSendGift) {
          newErrors.referredSendGift = "Who referred & send gift is required";
        }
      }
    }

    step2Data.clientinfo.forEach((clientId, index) => {
      let clientError = {};
      const contact = getContactById(clientId);

      if (!clientId || clientId === "") {
        clientError.clientName = "Client is required";
      }

      clientErrors[index] = clientError;
    });

    // A form with NO contact rows skipped the loop above entirely, so a request
    // could go through with nobody attached. Catch that case explicitly.
    if (hasNoClient(step2Data.clientinfo) && clientErrors.length === 0) {
      clientErrors[0] = { clientName: "Client is required" };
    }

    if (clientErrors.length > 0) {
      newErrors.clientErrors = clientErrors;
    }

    setErrors(newErrors);

    const hasFieldErrors = Object.keys(newErrors).some(
      (key) => key !== "clientErrors",
    );

    const hasClientErrors = clientErrors.some(
      (err) => Object.keys(err).length > 0,
    );

    if (hasFieldErrors || hasClientErrors) {
      // Inline field errors are easy to miss when the offending field is
      // scrolled out of view — the button just looked dead. Say what's missing.
      const missing = describeMissing(newErrors);
      toast.error(
        missing.length
          ? `Can't submit yet. Still needed: ${missing.join(", ")}.`
          : "Can't submit yet. Some required fields are missing.",
      );
      return;
    }
    // Is this property already in the system? A warning, not a block: a genuine
    // relist of the same address must still be able to go through.
    const duplicates = await findDuplicatesForAddress(formData.propertyAddress);
    if (duplicates.length > 0) {
      const goAhead = await confirm({
        title: "This property is already in the system",
        body: describeMatches(duplicates),
        note: "Submit anyway only if this really is a new, separate listing for the same address.",
        confirmLabel: "Submit anyway",
        cancelLabel: "Cancel",
      });
      if (!goAhead) return;
    }

    let id = Date.now();
    setIsLoading(true);

    try {
      let imageUrls = [];

      // Look up the primary client's last name: it drives Drive folder naming
      // ("<address> — <lastname>"). The pipeline lead resolves its own client
      // names via buildIntakeLead below. Best-effort: failures fall back to "".
      let clientLastName = "";
      try {
        const firstClientId = step2Data.clientinfo.find((c) => c && c !== "");
        if (firstClientId) {
          let c = getContactById(firstClientId);
          if (!c || (!c.name && !c.firstname && !c.lastname)) {
            const [raw] = await getContactsByIds([firstClientId]);
            c = normalizeContact(raw) || c || {};
          }
          clientLastName = String(c?.lastname || "").trim();
        }
      } catch (err) {
        console.error("Couldn't resolve the client's last name:", err);
      }

      let newdata = {
        status: "Pending",
        requestType: "fileRequest",
        propertyphoto: imageUrls,
        // Used by folderName.js on the trigger to build the Drive
        // folder name "<address> — <lastname>".
        clientLastName,
        dealtype: type === "seller" ? "Seller" : "Buyer",
        customers: step2Data.clientinfo.filter((id) => id !== ""),
        dealStage: "Prospect",
        financingType: "",
        earnestMoney: "",
        offerPrice: "",
        propertyType: "",
        agentCommission: "",
        fixedagentcommission: "",
        agentData: formData.agentId,
        agentName: formData.agentName,
        brokeradminfee: "",
        captype: "",
        captypedescription: "",
        closingdate: "",
        inspection: "",
        propertyLocation: formData.propertyLocation,
        inspectionDeadline: "",
        financingDeadline: "",
        leadCommission: formData.leadsource.leadCommission,
        leadsource: formData.leadsource,
        propertyaddress: formData.propertyAddress,
        splitdescription: "Team Member Split",
        splittype: "TeamSplit",
        inhousereferral: false,
        teamleadName: "",
        flatfee: "",
        flatfeeamount: "",
        assignedteamlead: "",
        thirdpartyagentCommission: "",
        thirdpartyagentName: "",
        agentCommissionamount: "",
        bankcommission: "",
        buyersidecommissionrate: "",
        leadsourceCommissionamount: "",
        sellersidecommissionrate: "",
        takehomecommissionamount: "",
        teamleadCommissionamount: "",
        teamleaddiscount: "",
        agentdiscount: "",

        teamleadcommissionrate: "",
        thirdpartyagentcommissionamount: "",
        totalCommissionamount: "",
        totalcommissionrate: formData.commission,

        createdby: user.id,
        createdat: id,
        // Pipeline-first: a Listing/Buyer Request is worked as a pipeline lead,
        // not as a Deals Board card. We still create the deal here (so the
        // file-request wiring, approver/email notifications, and the Drive-folder
        // trigger all still fire) but soft-delete it immediately so it never
        // shows on the board. convertListingLeadToDeal restores it to Pre-Market
        // when the lead is signed (via the lead's sourceDealId).
        deletedAt: Date.now(),
        notes: formData.notes,
        fileDeadline: formData.fileDeadline,
        clientReferal: formData.clientReferal,
        dropOff: formData.dropOff,
        fileFormat: formData.fileFormat,
        formDeadline: formData.formDeadline,
        formType: formData.formType,
        listingDate: formData.listingDate,
        photoBook: formData.photoBook,
        propertyTrust: formData.propertyTrust,
        preListing: formData.preListing,
        expirationdate: formData.expirationdate || "",
        referredSendGift: formData.referredSendGift,
        sellHome: formData.sellHome,
        sellerDisclosure: formData.sellerDisclosure,
        tasks: [...(tasks?.Prospect || [])],
        taskStatusTracker: { Prospect: true },
      };

      let result = await saveitemwithid("deals", id.toString(), newdata);

      if (result === "success") {
        // Intake routing: also drop the request into the matching Pipeline so the
        // agent can work it as a lead (in addition to the Deals Board deal).
        // Runs in the background — the deal is already saved, so this side
        // effect shouldn't hold the form open.
        (async () => {
          try {
            // A form opened FROM a pipeline lead links that lead to the new
            // file instead of minting a second lead — the lead's card stays
            // the one card for this client, and "Sign the Listing" will
            // restore THIS file (sourceDealId round-trip). The form's agent
            // choice is copied onto the lead so graduation (which stamps the
            // LEAD's agent onto the deal) can't silently revert it.
            const linkLeadId =
              type === "seller" ? prefillRef.current?.sourceLeadId || "" : "";
            if (linkLeadId) {
              const linkRes = await updateListingLead(linkLeadId, {
                sourceDealId: String(id),
                ...(formData.agentId
                  ? {
                      assignedAgent: formData.agentId,
                      assignedAgentName: formData.agentName || "",
                    }
                  : {}),
              });
              // updateListingLead resolves {success:false} instead of
              // throwing — an unlinked lead would later re-prompt for a
              // SECOND file and graduate a bare deal, so tell the user.
              if (linkRes?.success === false) {
                toast.warn(
                  "File created, but it couldn't be tied to the pipeline lead — open the lead and check before requesting again.",
                );
              }
              return;
            }
            // Every client on the form rides onto the lead (primary +
            // co-clients), so the pipeline card shows both names. Names come
            // from the contacts the form already loaded; any id without a
            // cached name is fetched once as a fallback.
            const clientIds = step2Data.clientinfo.filter((cid) => cid);
            const contactsById = {};
            const missingIds = [];
            clientIds.forEach((cid) => {
              const c = getContactById(cid);
              if (c && (c.name || c.clientName || c.firstname || c.lastname)) {
                contactsById[cid] = c;
              } else {
                missingIds.push(cid);
              }
            });
            if (missingIds.length) {
              try {
                const fetched = await getContactsByIds(missingIds);
                (fetched || []).forEach((raw) => {
                  const c = normalizeContact(raw);
                  if (c?.id) contactsById[c.id] = c;
                });
              } catch (fetchErr) {
                console.error(
                  "Contact lookup for the pipeline lead failed:",
                  fetchErr,
                );
              }
            }
            const lead = buildIntakeLead({
              type,
              clientIds,
              contactsById,
              dealId: id,
              agent: {
                id: formData.agentId || "",
                name: formData.agentName || "",
                enteredById: user.id,
              },
              leadSourceObj: formData.leadsource,
              listingDate: formData.listingDate,
              notes: formData.notes,
            });
            if (type === "seller") {
              await saveListingLead({
                ...lead,
                propertyAddress: formData.propertyAddress || "",
              });
            } else {
              await saveBuyerLead(lead);
            }
          } catch (e) {
            console.error("Pipeline lead creation from file request failed:", e);
          }
        })();

        const prospectTasks = tasks?.Prospect || [];

        prospectTasks.forEach((task) => {
          if (task?.assignee) {
            newmessagesuccess(
              "New Task Assigned",
              task.assignee.id, // jis ko assign hua
              task?.title || "",
              task.id || "",
              "newtask",
              newdata.createdat,
            );
          }
        });
        toast.success(
          `${type === "seller" ? "Listing" : "Buyer"} Request created successfully!`,
        );
        getalldeal();

        if (newdata.status === "Pending") {
          // Fire-and-forget — approvers get their notification in the
          // background; the submitter shouldn't wait on the email round-trip.
          notifyApprovers({ ...newdata, createdat: id }, users, user).catch(
            (notifyErr) =>
              console.error("Failed to notify approvers:", notifyErr),
          );
          // Also email the configured Notifications recipients (Settings →
          // Notifications). Fire-and-forget — failures shouldn't block the
          // request creation.
          emailListingRequestRecipients(
            { ...newdata, createdat: id },
            user,
          ).catch((err) =>
            console.error("Listing request email blast failed:", err),
          );
        }

        if (type === "seller") {
          // Background — saving the appointment and reloading the full list
          // shouldn't hold the form open.
          (async () => {
          try {
            const primaryClientId = step2Data.clientinfo.find((c) => c !== "");
            const extractName = (c) =>
              (
                c?.name ||
                c?.clientName ||
                `${c?.firstname || ""} ${c?.lastname || ""}`.trim() ||
                ""
              ).trim();
            let prospectName = "";
            if (primaryClientId) {
              prospectName = extractName(getContactById(primaryClientId));
              if (!prospectName) {
                try {
                  const fresh = await getContactsByIds([primaryClientId]);
                  prospectName = extractName(fresh?.[0]);
                } catch (e) {
                  console.error("Contact re-fetch failed:", e);
                }
              }
            }
            const appointmentDate =
              formData.listingDate || new Date().toISOString().slice(0, 10);
            const forYear = new Date(appointmentDate).getFullYear();
            // propertyAddress is the Google Places formatted_address, which
            // already includes the city/state/zip, so we use it directly.
            const address = formData.propertyAddress || "";

            await saveListingAppointment({
              agentId: formData.agentId,
              appointmentDate,
              prospectName,
              address,
              status: "pending",
              notes: formData.notes || "",
              forYear,
              dealId: id.toString(),
            });

            const items = await getListingAppointments();
            dispatch({
              type: actionType.STORE_LISTING_APPOINTMENTS,
              payload: items,
            });
          } catch (apptErr) {
            console.error("Failed to log listing appointment:", apptErr);
          }
          })();
        }
        setFormData((prev) => ({
          ...prev,
          agentName: user?.role === "Employee" ? prev.agentName : "",
          agentId: user?.role === "Employee" ? prev.agentId : "",
          leadsource: "",
          formType: "",
          listingDate: "",
          fileDeadline: "",
          formDeadline: "",
          fileFormat: "",
          propertyAddress: "",
          propertyLocation: {
            lat: "",
            lng: "",
          },
          commission: type === "seller" ? 3.5 : 2.7,
          sellerDisclosure: "",
          propertyTrust: "",
          sellHome: "",
          photoBook: "",
          preListing: "",
          expirationdate: "",
          dropOff: "",
          clientReferal: "",
          referredSendGift: "",
          notes: "",
        }));
        setSelectedLead("");

        setStep2Data({
          clientinfo: [""],
        });

        setErrors({ clientErrors: [] });
        setIsLoading(false);

        // Return to the dashboard so the agent isn't staring at a blank
        // form. Toasts above persist across the navigation.
        navigate("/dashboard");
      } else {
        toast.error(result || "Failed to create request");
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchContacts = async () => {
      console.log("Fetching contacts...");
      const userContacts = await getContactsForUser(user);
      setContactSyncData(userContacts);
    };

    if (user?.id) {
      fetchContacts();
    }
  }, [user?.id, user]);

  useEffect(() => {
    const fetchDealContacts = async () => {
      const validIds = step2Data.clientinfo.filter((id) => id !== "");
      if (!validIds.length) {
        setDealContactsData([]);
        return;
      }
      const contacts = await getContactsByIds(validIds);
      setDealContactsData(contacts);
    };

    fetchDealContacts();
  }, [step2Data.clientinfo]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      commission: type === "seller" ? 3.5 : 2.7,
    }));
  }, [type]);

  useEffect(() => {
    // A lead-driven prefill already chose the agent — don't overwrite it.
    if (prefillRef.current?.agentId) return;
    if (user?.role === "Employee" && employees?.length > 0) {
      const matchedEmployee = employees.find((emp) => emp.id === user.id);

      if (matchedEmployee) {
        setFormData((prev) => ({
          ...prev,
          agentName: matchedEmployee.firstname + " " + matchedEmployee.lastname,
          agentId: matchedEmployee.id,
        }));
      }
    }
  }, [user, employees]);

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
      })
      .catch((err) => {
        toast.error(String(err?.message || err));
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log("task templates", data);
    };

    fetchData();
  }, []);

  return (
    <div>
      <PageHeader
        title={type === "seller" ? "Listing Request" : "Buyer Request"}
      />

      <div className="w-[90%] lg:w-[80%] xl:w-[70%] mx-auto mt-5 mb-8">
        {dialog}
        <form onSubmit={handleSubmit}>
          <div className="bg-white rounded-2xl p-7 mb-5 shadow-md">
            <h2 className="font-semibold text-2xl mb-4">Agent & File Info</h2>

            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-[49%] flex flex-col gap-5">
                <div className="flex flex-col relative">
                  {heading("Agent Name", true)}

                  <div
                    onClick={() => {
                      if (user?.role !== "Employee") {
                        setagentpopup(!agentpopup);
                      }
                    }}
                    className={`w-full border-2 ${
                      errors.agentName ? "border-red-500" : "border-gray-300"
                    } ${
                      formData.agentName === "" ? "text-gray-400" : "text-black"
                    } rounded-lg p-2 ${
                      user?.role === "Employee"
                        ? "bg-gray-100 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    {formData.agentName || "Select Agent"}
                  </div>

                  {errors.agentName && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.agentName}
                    </span>
                  )}
                  {user?.role !== "Employee" && (
                    <UserPopUp
                      style={{ top: "70px" }}
                      visible={agentpopup}
                      activateoutsidecontainerclick={() => {
                        setagentpopup(false);
                      }}
                      data={employees.filter(
                        (emp) => emp.type !== 1 && emp.type !== 2,
                      )}
                      onClickcorrect={(item) => {
                        handleChange(
                          "agentName",
                          item.firstname + " " + item.lastname,
                        );
                        setFormData((prev) => ({
                          ...prev,
                          agentId: item.id,
                        }));
                        setagentpopup(false);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="w-full lg:w-[49%] flex relative flex-col mt-3 lg:mt-0">
                {heading("Lead Source", true)}

                <div
                  onClick={() => setleadpopup(!leadpopup)}
                  className={`w-full border-2 border-gray-300 ${
                    selectedLead === "" ? "text-gray-400" : "text-textcolor"
                  } rounded-lg p-2 cursor-pointer ${
                    errors.leadsource ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  {selectedLead === "" ? "Select Lead Source" : selectedLead}
                </div>
                {errors.leadsource && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.leadsource}
                  </span>
                )}

                <LeadSourcePopup
                  style={{ top: "70px" }}
                  visible={leadpopup}
                  data={[...leadsource]}
                  activateoutsidecontainerclick={() => setleadpopup(false)}
                  onClickcorrect={(value) => {
                    setSelectedLead(value.abbreviation);
                    handleChange("leadsource", value);
                    setleadpopup(false);
                  }}
                />
              </div>
            </div>
            {type === "seller" && (
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  {heading("Listing Appointment Date", false)}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="MM/DD/YYYY"
                      value={formatDates(formData.listingDate)}
                      readOnly
                      onClick={openDatePicker}
                      className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                    ></input>
                    <div
                      className="absolute top-3 right-3"
                      onClick={openDatePicker}
                    >
                      <Calendar size={18} />
                    </div>
                    <input
                      type="date"
                      id="inspectionDeadline"
                      ref={hiddenDateRef}
                      value={formData.listingDate || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          listingDate: e.target.value,
                        })
                      }
                      className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                    ></input>
                  </div>
                </div>
                <div className="w-full lg:w-[49%] mt-3">
                  {heading("Need File No Later Than", false)}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="MM/DD/YYYY"
                      value={formatDates(formData.fileDeadline)}
                      readOnly
                      onClick={openDatePicker2}
                      className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                    ></input>
                    <div
                      className="absolute top-3 right-3"
                      onClick={openDatePicker2}
                    >
                      <Calendar size={18} />
                    </div>
                    <input
                      type="date"
                      id="inspectionDeadline"
                      ref={hiddenDateRef2}
                      value={formData.fileDeadline || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          fileDeadline: e.target.value,
                        })
                      }
                      className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                    ></input>
                  </div>
                </div>
              </div>
            )}
            <div className="mt-5">
              {type === "seller" && (
                <div className="w-full lg:w-[49%] mt-3 lg:mt-0">
                  <div className="flex flex-col relative">
                    {heading("Form Type", true)}

                    <div
                      onClick={() => setFormTypePopup(!formTypePopup)}
                      className={`w-full border-2 ${
                        errors.formType ? "border-red-500" : "border-gray-300"
                      } ${
                        !formData.formType ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {formTypes.find((f) => f.value === formData.formType)
                        ?.label || "Select Form Type"}
                    </div>

                    {errors.formType && (
                      <span className="text-red-500 text-sm mt-1">
                        {errors.formType}
                      </span>
                    )}

                    <SelectPopUp
                      visible={formTypePopup}
                      data={formTypes}
                      onClose={() => setFormTypePopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        handleChange("formType", item.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {type === "buyer" && (
                <div className="w-full lg:w-[49%] mt-3 lg:mt-0">
                  {heading("Need Forms No Later Than", false)}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="MM/DD/YYYY"
                      value={formatDates(formData.formDeadline)}
                      readOnly
                      onClick={openDatePicker2}
                      className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                    ></input>
                    <div
                      className="absolute top-3 right-3"
                      onClick={openDatePicker2}
                    >
                      <Calendar size={18} />
                    </div>
                    <input
                      type="date"
                      id="inspectionDeadline"
                      ref={hiddenDateRef2}
                      value={formData.formDeadline || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          formDeadline: e.target.value,
                        })
                      }
                      className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                    ></input>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-5">
              {heading("File Format", true)}

              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                {[
                  "Full Physical",
                  "Full Digital",
                  "Part Physical & Digital",
                ].map((option, index) => (
                  <label
                    key={index}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="fileFormat"
                      value={option}
                      checked={formData.fileFormat === option}
                      onChange={(e) =>
                        handleChange("fileFormat", e.target.value)
                      }
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>

              {errors.fileFormat && (
                <span className="text-red-500 text-sm mt-1">
                  {errors.fileFormat}
                </span>
              )}
            </div>

            {type === "buyer" && (
              <div className="mt-3">
                {heading("Buyer Commission (%)", false)}
                <input
                  type="number"
                  placeholder="Enter Commission"
                  value={formData.commission || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      commission: e.target.value,
                    });
                  }}
                  className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                />
              </div>
            )}
          </div>
          {type === "seller" && (
            <div className="bg-white rounded-2xl p-7 mb-5 shadow-md">
              <h2 className="font-semibold text-2xl mb-4">Property Details</h2>
              <div className="flex flex-col lg:flex-row lg:justify-between w-full mt-3">
                <div className="w-full relative">
                  {heading("Property Address", true)}

                  <Autocomplete
                    onLoad={(ref) => (autoCompleteRef.current = ref)}
                    onPlaceChanged={handlePlaceChanged}
                  >
                    <input
                      type="text"
                      placeholder="123 Main Street"
                      value={formData.propertyAddress || ""}
                      onChange={(e) =>
                        handleChange("propertyAddress", e.target.value)
                      }
                      className={`w-full border-2 ${
                        errors.propertyAddress
                          ? "border-red-500"
                          : "border-gray-300"
                      } rounded-lg p-2 pr-10 focus:border-[#1E293B] outline-none`}
                    />
                  </Autocomplete>
                  {errors.propertyAddress && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.propertyAddress}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  {heading("Commission (%)", false)}
                  <input
                    type="number"
                    placeholder="Enter Commission"
                    value={formData.commission || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        commission: e.target.value,
                      })
                    }
                    className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                  />
                </div>
              </div>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  <div className="flex flex-col relative">
                    {heading("Property in a Trust?", true)}

                    <div
                      onClick={() => setPropertyTrustPopup(!propertyTrustPopup)}
                      className={`w-full border-2 ${
                        errors.propertyTrust
                          ? "border-red-500"
                          : "border-gray-300"
                      } ${
                        !formData.propertyTrust ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {yesNoOptions.find(
                        (f) => f.value === formData.propertyTrust,
                      )?.label || "Select"}
                    </div>

                    {errors.propertyTrust && (
                      <span className="text-red-500 text-sm mt-1">
                        {errors.propertyTrust}
                      </span>
                    )}

                    <SelectPopUp
                      visible={propertyTrustPopup}
                      data={yesNoOptions}
                      onClose={() => setPropertyTrustPopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        handleChange("propertyTrust", item.value);
                      }}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-[49%] mt-3">
                  <div className="flex flex-col relative">
                    {heading("Sellers Disclosure", false)}

                    <div
                      onClick={() => setSellerPopup(!sellerPopup)}
                      className={`w-full border-2 ${
                        !formData.sellerDisclosure
                          ? "text-gray-400"
                          : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {sellerDisclouser.find(
                        (f) => f.value === formData.sellerDisclosure,
                      )?.label || "Select Seller Disclosure"}
                    </div>

                    <SelectPopUp
                      visible={sellerPopup}
                      data={sellerDisclouser}
                      onClose={() => setSellerPopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        setFormData({
                          ...formData,
                          sellerDisclosure: item.value,
                        });
                        setSellerPopup(false);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  <div className="flex flex-col relative">
                    {heading("Did You Sell Them The Home?", false)}

                    <div
                      onClick={() => setsellHomePopup(!sellHomePopup)}
                      className={`w-full border-2 ${
                        errors.sellHome ? "border-red-500" : "border-gray-300"
                      } ${
                        !formData.sellHome ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {yesNoOptions.find((f) => f.value === formData.sellHome)
                        ?.label || "Select"}
                    </div>

                    <SelectPopUp
                      visible={sellHomePopup}
                      data={yesNoOptions}
                      onClose={() => setsellHomePopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        setFormData({
                          ...formData,
                          sellHome: item.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-[49%] mt-3">
                  <div className="flex flex-col relative">
                    {heading("Want a Photo Book?", false)}

                    <div
                      onClick={() => setPhotoBookPopup(!photoBookPopup)}
                      className={`w-full border-2 ${
                        errors.photoBook ? "border-red-500" : "border-gray-300"
                      } ${
                        !formData.photoBook ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {yesNoOptions.find((f) => f.value === formData.photoBook)
                        ?.label || "Select"}
                    </div>

                    <SelectPopUp
                      visible={photoBookPopup}
                      data={yesNoOptions}
                      onClose={() => setPhotoBookPopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        setFormData({
                          ...formData,
                          photoBook: item.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="bg-white rounded-2xl p-7 mb-5 shadow-md">
            <h2 className="font-semibold text-2xl mb-4">Client Information</h2>

            <div className="mt-4 space-y-2">
              {step2Data.clientinfo.map((client, index) => {
                if (!client) return null;
                const contact = getContactById(client);
                const hasError = errors.clientErrors?.[index]?.clientName;
                return (
                  <div
                    key={`${client}-${index}`}
                    className={`relative group p-4 rounded-lg bg-gray-50 border ${
                      hasError ? "border-red-400" : "border-transparent"
                    }`}
                  >
                    <div className="absolute top-3 right-3 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition">
                      <button
                        type="button"
                        onClick={() => handleEditClient(contact)}
                        className="inline-flex items-center gap-1 text-xs font-medium text-slate-600 bg-white border border-slate-200 hover:border-slate-400 hover:text-slate-900 rounded-md px-2 py-1 shadow-sm"
                      >
                        <Pencil size={12} /> Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => handleRemoveClient(index)}
                        className="inline-flex items-center gap-1 text-xs font-medium text-red-600 bg-white border border-red-200 hover:border-red-400 hover:bg-red-50 rounded-md px-2 py-1 shadow-sm"
                        aria-label="Remove client"
                      >
                        <Trash2 size={12} />
                      </button>
                    </div>
                    <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-400 mb-1">
                      Client {index + 1}
                    </div>
                    <div className="text-sm font-semibold text-slate-900">
                      {contact.name || "(no name)"}
                    </div>
                    <div className="text-[13px] text-slate-600 mt-0.5 flex flex-wrap gap-3">
                      {contact.email && <span>{contact.email}</span>}
                      {contact.phone && (
                        <span>{formatPhone(contact.phone)}</span>
                      )}
                    </div>
                    {hasError && (
                      <span className="text-red-500 text-sm mt-1 block">
                        {errors.clientErrors[index].clientName}
                      </span>
                    )}
                  </div>
                );
              })}

              {/* Centered dashed-border CTA — always visible. Doubles as the
                  empty-state and add-another action. */}
              <button
                type="button"
                onClick={handleAddClient}
                className="w-full mt-1 px-4 py-6 border-2 border-dashed border-slate-300 hover:border-[#1E293B] hover:bg-slate-50 rounded-xl flex flex-col items-center justify-center gap-2 transition cursor-pointer"
              >
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-[#0f172a] to-[#1E293B] flex items-center justify-center">
                  <FaPlus className="text-white" size={18} />
                </div>
                <div className="text-sm font-semibold text-slate-900">
                  {step2Data.clientinfo.filter((id) => id).length === 0
                    ? "Add a Client"
                    : "Add Another Client"}
                </div>
                <div className="text-xs text-slate-500">
                  Pick from your contacts or create a new one
                </div>
              </button>
            </div>
          </div>

          {pickerOpen && (
            <AddClientPicker
              userId={user?.id}
              existingCustomerIds={step2Data.clientinfo.filter((id) => id)}
              onClose={() => setPickerOpen(false)}
              onPick={(contactId) => {
                setPickerOpen(false);
                attachClient(contactId);
              }}
              onCreateNew={() => {
                setPickerOpen(false);
                setCreatingContact(true);
              }}
            />
          )}

          {editingContact && (
            <ContactEditDrawer
              initial={editingContact}
              onClose={() =>
                !contactSaving && setEditingContact(null)
              }
              onSubmit={handleSaveEditedContact}
              saving={contactSaving}
            />
          )}

          {creatingContact && (
            <ContactEditDrawer
              initial={null}
              onClose={() =>
                !contactSaving && setCreatingContact(false)
              }
              onSubmit={handleCreateNewContact}
              saving={contactSaving}
            />
          )}
          {type === "seller" && (
            <div className="bg-white rounded-2xl p-7 mb-5 shadow-md">
              <h2 className="font-semibold text-2xl mb-4">
                Additional Details
              </h2>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%]">
                  <div className="flex flex-col relative">
                    {heading("Pre-Listing Drop Off", true)}

                    <div
                      onClick={() => setPreListingPopup(!preListingPopup)}
                      className={`w-full border-2 ${
                        errors.preListing ? "border-red-500" : "border-gray-300"
                      } ${
                        !formData.preListing ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {yesNoOptions.find((f) => f.value === formData.preListing)
                        ?.label || "Select"}
                    </div>

                    <SelectPopUp
                      visible={preListingPopup}
                      data={yesNoOptions}
                      onClose={() => setPreListingPopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        handleChange("preListing", item.value);
                      }}
                    />
                    {errors.preListing && (
                      <span className="text-red-500 text-sm mt-1">
                        {errors.preListing}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-[49%] mt-3 lg:mt-0">
                  {heading("Drop Off By", false)}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="MM/DD/YYYY"
                      value={formatDates(formData.dropOff)}
                      readOnly
                      onClick={openDatePicker3}
                      className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                    ></input>
                    <div
                      className="absolute top-3 right-3"
                      onClick={openDatePicker3}
                    >
                      <Calendar size={18} />
                    </div>
                    <input
                      type="date"
                      id="dropOff"
                      ref={hiddenDateRef3}
                      value={formData.dropOff || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          dropOff: e.target.value,
                        })
                      }
                      className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                    ></input>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  {heading("Listing Expiration Date", false)}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="MM/DD/YYYY"
                      value={formatDates(formData.expirationdate)}
                      readOnly
                      onClick={openDatePicker4}
                      className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none"
                    ></input>
                    <div
                      className="absolute top-3 right-3"
                      onClick={openDatePicker4}
                    >
                      <Calendar size={18} />
                    </div>
                    <input
                      type="date"
                      id="expirationdate"
                      ref={hiddenDateRef4}
                      value={formData.expirationdate || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          expirationdate: e.target.value,
                        })
                      }
                      className="absolute left-0 top-0 w-0 h-0 opacity-0 pointer-events-none"
                    ></input>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap justify-between">
                <div className="w-full lg:w-[49%] mt-3">
                  <div className="flex flex-col relative">
                    {heading("Client Referral?", false)}

                    <div
                      onClick={() => setClientReferPopup(!clientReferPopup)}
                      className={`w-full border-2 ${
                        errors.clientReferal
                          ? "border-red-500"
                          : "border-gray-300"
                      } ${
                        !formData.clientReferal ? "text-gray-400" : "text-black"
                      } rounded-lg p-2 cursor-pointer`}
                    >
                      {yesNoOptions.find(
                        (f) => f.value === formData.clientReferal,
                      )?.label || "Select"}
                    </div>

                    <SelectPopUp
                      visible={clientReferPopup}
                      data={yesNoOptions}
                      onClose={() => setClientReferPopup(false)}
                      style={{ top: "70px" }}
                      onSelect={(item) => {
                        setFormData({
                          ...formData,
                          clientReferal: item.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-[49%] mt-3">
                  {heading(
                    "Who referred & send gift?",
                    formData.clientReferal === "yes",
                  )}
                  <input
                    type="text"
                    value={formData.referredSendGift || ""}
                    placeholder="Enter referral name"
                    onChange={(e) =>
                      handleChange("referredSendGift", e.target.value)
                    }
                    className={`w-full border-2 ${
                      errors.referredSendGift
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
                  ></input>
                  {errors.referredSendGift && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.referredSendGift}
                    </span>
                  )}
                </div>
              </div>
              <div className="mt-3">
                {heading("Notes")}

                <textarea
                  rows={4}
                  placeholder="Enter any additional notes..."
                  value={formData.notes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      notes: e.target.value,
                    })
                  }
                  className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none resize-none"
                />
              </div>
            </div>
          )}
          {type === "buyer" && (
            <div className="bg-white rounded-2xl p-7 mb-5 shadow-md">
              <h2 className="font-semibold text-2xl mb-4">Notes</h2>
              <div className="mt-5">
                {heading("Notes")}

                <textarea
                  rows={4}
                  placeholder="Enter any additional notes..."
                  value={formData.notes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      notes: e.target.value,
                    })
                  }
                  className="w-full border-2 border-gray-300 rounded-lg p-2 focus:border-[#1E293B] outline-none resize-none"
                />
              </div>
            </div>
          )}
          <div className="flex justify-center lg:justify-end gap-4 mt-6">
            <div
              class="px-5 py-2.5 rounded-lg cursor-pointer font-semibold text-sm inline-flex items-center gap-2 transition-all duration-300 bg-white border-2 border-gray-300 text-gray-500 hover:border-themeColor hover:text-themeColor"
              onClick={() => handleNavigate()}
            >
              Cancel
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className={`px-5 py-2.5 rounded-lg border-0 font-semibold text-sm inline-flex items-center gap-2 transition-all duration-300 bg-[#1E293B] text-white shadow-[0_4px_15px_rgba(99,102,241,0.3)] ${
                isLoading
                  ? "opacity-60 cursor-not-allowed"
                  : "cursor-pointer hover:bg-[#1E293B] hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(99,102,241,0.4)]"
              }`}
            >
              {isLoading && (
                <div role="status" className="pl-3">
                  <svg
                    aria-hidden="true"
                    class="size-5 text-gray-200 animate-spin dark:text-white fill-themeColor"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="sr-only">Loading...</span>
                </div>
              )}
              Submit & Create Deal <MoveRight size={14} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function heading(title, required) {
  return (
    <div className={`flex flex-row ${required ? "mb-1" : "mb-2"}`}>
      <label className="block font-medium text-sm">{title}</label>
      {required && <span className="text-red-700 ml-1">*</span>}
    </div>
  );
}

function formatPhone(value) {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export default MainListRequest;
